import _import from '../lazy-importer';
import Layout from '@/views/console/mongodb/layout/Layout';
import { setDatabaseType } from '@/utils/helpers';

const basicPath = '/console/mongodb';

const routes = [
  {
    path: `${basicPath}`,
    component: Layout,
    redirect: { name: 'MongodbIndex' },
    children: [
      {
        path: 'index',
        name: 'MongodbIndex',
        component: _import('console/mongodb/static/Index'),
        meta: { title: '首页' }
      }
    ]
  },
  {
    path: `${basicPath}/terminal`,
    name: 'MongodbTerminal',
    component: Layout,
    meta: { inNav: true },
    children: [
      {
        path: 'index',
        name: 'MongodbTerminalIndex',
        component: _import('console/mongodb/terminal/Index'),
        meta: { title: '查询窗口', inNav: true }
      }
    ]
  }
];

export default setDatabaseType(routes, 'MONGODB');
